import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    viewBox="0 0 76.2 76.2"
    {...props}
  >
    <g id="backgroung-svg3" transform="translate(0 -58.833)">
      <circle
        id="backgroung-svg"
        cx={38.128}
        cy={96.829}
        r={35.49}
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeWidth={4.763}
      />
      <g transform="translate(-4.112 54.925) scale(1.0493)">
        <circle cx={30.884} cy={29.65} r={4.992} />
        <circle cx={50.463} cy={29.65} r={4.992} />
        <path
          id="backgroung-svg2"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeWidth={4.539}
          d="M26.593 46.992c5.682 11.966 21.604 12.91 27.395-.134"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
